export interface ILogData {
    level?: string | number;
    origin?: string;
    message?: string;
    context?: {
        _args?: string;
        _url?: string;
        _line?: number;
        _column?: number;
    };
}

/**
 * Logger - wykonuje request do kibany z błędami
 *
 * @param {ILogData} data - dane do przekazania do logera
 * @returns {void}
 */
export const logToKibana = (data: ILogData): void => {
    try {
        const url = '//l.iplsc.com/logger/';
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'text/plain');

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    console.log('Message to the logger was sent successfully.');
                } else {
                    console.error(`Error while sending message to logger: ${xhr.status} -  ${xhr.statusText}`);
                }
            }
        };

        const loggerData = JSON.stringify({
            origin: 'ads',
            referer: location.href,
            ...data,
            context: { _line: 0, _column: 0, _args: '', ...data.context },
        });

        xhr.send(loggerData);
    } catch (e) {
        console.error(e);
    }
};
